import { Box, IconButton } from '@mui/material'
import React from 'react'
import AddIcon from '@mui/icons-material/Add'
import ClearIcon from '@mui/icons-material/Clear'
import { removeMime } from '../../lib/helpers'

const AddDamagedSectionPhoto = ({
  damagePhotos,
  onImageUpload,
  removeDamagePhoto,
}: {
  damagePhotos: string[] | undefined
  onImageUpload: (e: React.ChangeEvent<HTMLInputElement>) => void
  removeDamagePhoto: (i: number) => void
}) => (
  <>
    <input
      accept="image/jpeg, image/jpg, image/png"
      id="upload-damage-img"
      type="file"
      hidden
      onChange={(e) => onImageUpload(e)}
    />
    <Box width="100%" display="flex" overflow="auto">
      {damagePhotos?.map((photoURL: string | undefined, index: number) => {
        return (
          <Box
            key={removeMime(photoURL)}
            sx={{
              width: 156,
              height: 156,
              display: 'flex',
              alignItems: 'center',
              position: 'relative',
              borderRadius: (theme) => theme.spacing(0.5),
              overflow: 'hidden',
              flexShrink: 0,
              justifyContent: 'center',
              backgroundColor: '#f1f1f1',
              '& + div, & + label': {
                marginLeft: (theme) => theme.spacing(1),
              },
            }}
          >
            <img src={photoURL} width="100%" alt="Attached damage section" />
            <IconButton
              sx={(theme) => ({
                position: 'absolute',
                padding: theme.spacing(0.125),
                backgroundColor: 'rgba(0,0,0,.25) !important',
                color: '#fff',
                top: theme.spacing(2),
                right: theme.spacing(2),
              })}
              onClick={() => {
                removeDamagePhoto(index)
              }}
            >
              <ClearIcon />
            </IconButton>
          </Box>
        )
      })}
      <label htmlFor="upload-damage-img">
        <Box
          sx={{
            width: 156,
            height: 156,
            display: 'flex',
            alignItems: 'center',
            position: 'relative',
            borderRadius: (theme) => theme.spacing(0.5),
            overflow: 'hidden',
            flexShrink: 0,
            justifyContent: 'center',
            backgroundColor: '#f1f1f1',
            '& + div, & + label': {
              marginLeft: (theme) => theme.spacing(1),
            },
          }}
        >
          <AddIcon color="primary" />
        </Box>
      </label>
    </Box>
  </>
)

export default AddDamagedSectionPhoto
